import { keyBy } from 'lodash';

import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';

import {
  type AdvancedFilters,
  baseFiltersOptions,
  type FilterSelectType,
  type FilterType,
} from '~/components/FiltersMenu/types';
import { getFilterProps } from '~/components/FiltersMenu/utils/getFilterProps';
import { type SelectedFilter } from '~/store/filters/types';

export const getAdvancedFiltersOptions = ({
  selectedFilters,
  advancedFilters,
  onSelect,
  disabledFilters,
}: {
  selectedFilters: SelectedFilter[];
  advancedFilters: AdvancedFilters[];
  onSelect: FilterSelectType;
  disabledFilters?: FilterType[];
}) => {
  const selectedFiltersTypes = keyBy(selectedFilters, 'type');

  const options: DropdownMenuOption[] = advancedFilters.map((advancedFilter) => ({
    ...getFilterProps({
      type: advancedFilter,
      onSelect: onSelect,
      isSelected: !!selectedFiltersTypes[advancedFilter],
      disabled: disabledFilters?.includes(advancedFilter),
    }),
    label: baseFiltersOptions[advancedFilter].label,
    prefix: null,
    type: 'item',
  }));

  return options;
};
